<template>
    <div class="question-item">
        <div class="question-title">{{question.title}}</div>
        <div class="option-container">
            <input v-if="!completeType" @change="inputChangeHandler" type="text" v-model="question.input">
            <div v-else-if="completeType === 'notCycle'">
                <dateTimePicker @changeHandler="changeHandler" :date="valueBefore.value[0]"></dateTimePicker>
            </div>
            <div v-else>
                <dateTimePicker @changeHandler="changeHandler" :date="valueBefore.value[0]"></dateTimePicker>
                <span>至</span>
                <dateTimePicker @changeHandler="changeHandler($event,'isCycle')"
                                :date="valueBefore.value[1]"></dateTimePicker>
            </div>
            <van-field v-if="isUpload" name="uploader" style="padding-top: .24rem;">
                <template #input>
                    <van-uploader @delete="deleteHandler" multiple :after-read="afterRead" v-model="uploader"
                                  :max-count="5"/>
                </template>
            </van-field>
        </div>
    </div>
</template>

<script>
    import dateTimePicker from './dateTimePickerN'

    export default {
        name: 'question-complete',
        props: {
            question: {required: true},
        },
        data() {
            return {
                valueBefore: {
                    value: [{yearSelect: '',monthSelect: '',daySelect: ''},{yearSelect: '',monthSelect: '',daySelect: ''}],
                },
                value: {front: '', end: ''},
                show: false,
                uploader: [],
                imageList: [],
                fileList: [],
            }
        },
        computed: {
            completeType() {
                if (!this.question.format) {
                    return false
                } else if (this.question.format === '3') {
                    return 'notCycle'
                } else {
                    return 'cycle'
                }
            },
            isUpload() {
                return this.question.upload === '1'
            }
        },
        components: {dateTimePicker},
        created() {
        },
        watch: {
            'question.answer': {
                handler(val) {
                    if (val) {
                        this.getAnswer()
                    }
                },
                immediate: true
            }
        },
        mounted() {
            // this.question.value = [{
            //     input: "",
            //     upload: {
            //         type: 'pic',
            //         url: "",
            //         brief: "",
            //     }
            // }]
        },
        methods: {
            getAnswer() {
                if (this.question.hasOwnProperty('answer')) {
                    this.inputChangeHandler()
                        .then(() => {
                            this.question['input'] = this.question.answer[0].answer
                            this.question.value[0].input = this.question.answer[0].answer
                            this.getAnswerTimeHandler(this.question.answer[0].answer)
                            this.$forceUpdate()
                        })

                }
            },
            getAnswerTimeHandler(answer) {
                if(this.completeType) {
                    if (answer.indexOf(':') != -1) {
                        let arr = answer.split(':')
                        this.value.front = arr[0]
                        this.value.end = arr[1]
                        arr.forEach((answerItem,index) => {
                            this.timeHandlerWith_(answerItem,index)
                        })
                    }else {
                        this.timeHandlerWith_(answer,0)
                    }
                }
            },
            timeHandlerWith_(answer,index) {
                let arr = answer.split('-');
                this.valueBefore.value[index].yearSelect = this.reTimeHandler(arr[0])
                this.valueBefore.value[index].monthSelect = this.reTimeHandler(arr[1])
                this.valueBefore.value[index].daySelect = this.reTimeHandler(arr[2])
            },
            inputChangeHandler() {
                return new Promise(resolve => {
                    if (!this.question.value) {
                        this.question.value = [{
                            input: "",
                            upload: {
                                type: 'pic',
                                url: "",
                                brief: "",
                            }
                        }]
                    }
                    // this.question.value = [{input: this.question.input}]
                    this.question.value[0].input = this.question.input
                    resolve()
                })
            },
            changeHandler(val, type) {
                this.question.value = [{
                    input: "",
                    upload: {
                        type: 'pic',
                        url: "",
                        brief: "",
                    }
                }]
                if (this.completeType === 'notCycle') {
                    this.question.value[0].input = `${this.timeHandler(val.yearSelect)}${this.timeHandler(val.monthSelect) ? ('-' + this.timeHandler(val.monthSelect)) : ''}${this.timeHandler(val.daySelect) ? ('-' + this.timeHandler(val.daySelect)) : ''}`
                } else {
                    if (!type) {
                        this.value['front'] = `${this.timeHandler(this.valueBefore.value[0].yearSelect)}${this.timeHandler(this.valueBefore.value[0].monthSelect) ? ('-' + this.timeHandler(this.valueBefore.value[0].monthSelect)) : ''}${this.timeHandler(this.valueBefore.value[0].daySelect) ? ('-' + this.timeHandler(this.valueBefore.value[0].daySelect)) : ''}`
                    } else {
                        this.value['end'] = `${this.timeHandler(this.valueBefore.value[1].yearSelect)}${this.timeHandler(this.valueBefore.value[1].monthSelect) ? ('-' + this.timeHandler(this.valueBefore.value[1].monthSelect)) : ''}${this.timeHandler(this.valueBefore.value[1].daySelect) ? ('-' + this.timeHandler(this.valueBefore.value[1].daySelect)) : ''}`
                    }
                    this.question.value[0].input = `${this.value.front}:${this.value.end}`
                }


            },
            timeHandler(time) {
                if (time === '不清楚') {
                    return 'x'
                } else if (time === '上半年') {
                    return 'a'
                } else if (time === '下半年') {
                    return 'b'
                } else {
                    return time
                }
            },
            reTimeHandler(time) {
                if (time === 'x') {
                    return '不清楚'
                } else if (time === 'a') {
                    return '上半年'
                } else if (time === 'b') {
                    return '下半年'
                } else {
                    return time
                }
            },
            deleteHandler() {
                this.imageList = []
                if (!this.uploader.length) {
                    this.question.options[this.currentIndex - 1].uploadImage = ''
                } else {
                    this.afterRead(this.uploader)
                }
            },
            afterRead(file) {
                if (Object.prototype.toString.call(file) == '[object Array]') {
                    file.forEach(v => {
                        // v.status = 'uploading'
                        this.uploadImage(v.file)
                            .then((res) => {
                                this.imageList.push(res.url)
                                this.question.value[0].upload.url = this.imageList.join(',')
                            })
                            .catch(() => {
                                v.status = 'failed'
                            })
                    })
                } else {
                    // file.status = 'uploading'
                    this.uploadImage(file.file)
                        .then((res) => {
                            this.imageList.push(res.url)
                            this.question.value[0].upload.url = this.imageList.join(',')
                        })
                        .catch(() => {
                            file.status = 'failed'
                        })
                }
            },
            uploadImage(file) {
                return new Promise((resolve, reject) => {
                    let uploadData = {}
                    uploadData.file = file
                    uploadData.url = file.name
                    uploadData.objName = `questionAnswerUrl/2021/${Math.floor(Math.random()) + new Date().getTime()}`
                    this.$store.dispatch('put', uploadData)
                        .then(res => {
                            if (res.res.status == 200) {
                                //console.log(res);
                                resolve(res)
                            }
                        })
                        .catch((rej) => {
                            reject()
                        })
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    @import "questionCommon";

    .option-container {
        text-align: left;
        padding: 0 .24rem;

        input {
            padding: .05rem;
            border: 1px solid #ccc;
            border-radius: .03rem;
            width: 100%;
        }
    }
</style>